import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Loader from "../../../Components/UI/Loader";
import { onFetchCompanies } from "../../../store/actions/company";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import "./index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faEye,
  faMagnifyingGlass,
  faPenToSquare,
  faKey,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import ViewCompanies from "./ViewCompany";
import { AdminService } from "../../../services/admin.service";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../../routes/config";
import AddCompanyDialog from "./AddCompanyDialog";


const Companies = () => {

  const navigate = useNavigate();

  const companies = useAppSelector((state) => state.company.companies);
  const loader = useAppSelector((state) => state.company.loader);
  const dispatch = useAppDispatch();

  const [companyModal, setCompanyModal] = useState("");
  const [updatedPassword, setUpdatedPassword] = useState<any>(undefined);
  const [showSectionModal, setShowSectionModal] = useState<any>(false)

  const [toggle, setToggle] = useState(false);
  useEffect(() => {
    dispatch(onFetchCompanies());
  }, []);

  const CustomToggle = React.forwardRef(
    ({ children, onClick }: any, ref: any) => (
      <a
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </a>
    )
  );

  const handleChangePassword = async (userId: string) => {
    await AdminService.changeComapanyPasswordById(userId).then(res => {
      if (res.status === 200) {
        toast.success("Password reset successfully")
      }
    }).catch(e => {
      toast.error("Unable to change password! Something went Wrong")
    })
  }

  const toggleBlockUnBlock = async (userId: string) => {
    await AdminService.toggleBlockUnBlock(userId).then((res) => {
      if (res.status === 200) {
        toast.success("Updated Status");
      }
    }).catch((e) => {
      toast.error("Unable to change! Something went Wrong")
    })
  }

  return (
    <>
      {loader && <Loader />}{" "}
      {/* {<PasswordModal
        setShow={() => setUpdatedPassword(undefined)}
        show={updatedPassword ? true : false}
        body={updatedPassword}
      />} */}
      {companies && (
        <>
          <div className="ds-page-head">
            <div className="d-flex align-items-center">
              <h1 className="ds-page-title">Companies</h1>
              <span className="ds-count-pill">{companies?.length}</span>
            </div>
            <div className="ds-search-wrap">
              <FontAwesomeIcon icon={faMagnifyingGlass} className="ds-search-icon" />
              <input
                type="text"
                className="ds-search"
                placeholder="Search companies..."
              />
            </div>
          </div>

          <div className="ds-toolbar">
            <span className="ds-section-label">All Companies</span>
            <AddCompanyDialog />
          </div>
          {toggle && (
            <ViewCompanies id={companyModal} setToggle={setToggle} toggle={toggle} />
          )}

          <div className="ds-table-card mt-3">
            <div className="ds-thead">
              <div style={{ width: "44px" }}>#</div>
              <div style={{ flex: "1 1 240px" }}>Company</div>
              <div style={{ width: "120px" }}>Status</div>
              <div style={{ width: "150px" }}>Users</div>
              <div style={{ width: "170px" }}>Questions</div>
              <div style={{ width: "56px" }} className="text-end">
                Actions
              </div>
            </div>

            {companies?.map((data: any, index: number) => {
              const blocked = data.company.blocked === true;
              const userMax = Number(data.company.numberOfUsers) || 0;
              const qMax = Number(data.company.numberOfAllowedQuestions) || 0;
              const userPct = userMax
                ? Math.min(100, (Number(data.companyUserCount) / userMax) * 100)
                : 0;
              const qPct = qMax
                ? Math.min(100, (Number(data.questionCount) / qMax) * 100)
                : 0;
              const initials = (data.company.companyName || "NA")
                .trim()
                .slice(0, 2);
              const goToCompany = () =>
                navigate(baseUrl + "/" + "view-company" + "/" + data.company._id);
              return (
                <div className="ds-trow" key={data.company._id || index}>
                  <div className="ds-cell-muted" style={{ width: "44px" }}>
                    {index + 1}
                  </div>

                  <div
                    style={{
                      flex: "1 1 240px",
                      display: "flex",
                      gap: "0.75rem",
                      alignItems: "center",
                      minWidth: 0,
                    }}
                  >
                    <span className="ds-avatar">{initials}</span>
                    <div style={{ minWidth: 0 }}>
                      <div
                        className="ds-link ds-cell-strong text-truncate"
                        onClick={goToCompany}
                      >
                        {data.company.companyName || "NA"}{" "}
                        <FontAwesomeIcon icon={faEye} className="ms-1" />
                      </div>
                      <div className="ds-cell-label text-truncate">
                        {data.company.email || "NA"}
                      </div>
                    </div>
                  </div>

                  <div style={{ width: "120px" }}>
                    <span
                      className={`ds-badge ${
                        blocked ? "ds-badge--danger" : "ds-badge--success"
                      }`}
                    >
                      <span className="ds-dot" />
                      {blocked ? "Blocked" : "Active"}
                    </span>
                  </div>

                  <div style={{ width: "150px" }}>
                    <div className="ds-cell-value">
                      <span className="ds-cell-strong">
                        {data.companyUserCount}
                      </span>{" "}
                      <span className="ds-cell-muted">/ {userMax}</span>
                    </div>
                    <div
                      className={`ds-meter ${
                        userPct >= 90
                          ? "ds-meter--danger"
                          : userPct >= 70
                          ? "ds-meter--warn"
                          : ""
                      }`}
                    >
                      <span style={{ width: `${userPct}%` }} />
                    </div>
                  </div>

                  <div style={{ width: "170px" }}>
                    <div className="ds-cell-value">
                      <span className="ds-cell-strong">
                        {data.questionCount}
                      </span>{" "}
                      <span className="ds-cell-muted">/ {qMax}</span>
                    </div>
                    <div
                      className={`ds-meter ${
                        qPct >= 90
                          ? "ds-meter--danger"
                          : qPct >= 70
                          ? "ds-meter--warn"
                          : ""
                      }`}
                    >
                      <span style={{ width: `${qPct}%` }} />
                    </div>
                  </div>

                  <div
                    style={{ width: "56px" }}
                    className="d-flex justify-content-end"
                  >
                    <Dropdown align="end">
                      <Dropdown.Toggle
                        as={CustomToggle}
                        id="dropxdown-custom-components"
                      >
                        <span className="ds-icon-btn">
                          <FontAwesomeIcon icon={faEllipsisVertical} />
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            setCompanyModal(data?.company._id);
                            setToggle(!toggle);
                          }}
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                          Edit
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => {
                            handleChangePassword(data?.company._id);
                          }}
                        >
                          <FontAwesomeIcon icon={faKey} />
                          Reset Password
                        </Dropdown.Item>

                        <Dropdown.Item
                          onClick={() => {
                            toggleBlockUnBlock(data?.company._id);
                          }}
                        >
                          <FontAwesomeIcon icon={faBan} />
                          Block/Unblock
                        </Dropdown.Item>

                        <Dropdown.Divider />

                        <Dropdown.Item onClick={goToCompany}>
                          <FontAwesomeIcon icon={faEye} />
                          View
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )
      }
    </>
  );
};

export default Companies;
